import React, { Fragment } from 'react'

import { H2 } from '@frame/ui-primitives/h2'
import { Span } from '@frame/ui-primitives/span'

function getEmployerNameText(employerName?: string | null) {
  if (employerName) {
    return `at ${employerName}`
  }

  return ''
}

function getHeaderText({
  employerName,
  isMultiEmployer,
  verifierName,
  targetFirstName,
}: {
  employerName?: string | null
  isMultiEmployer: boolean
  verifierName?: string | null
  targetFirstName?: string | null
}) {
  const employerNameText = getEmployerNameText(employerName)

  if (isMultiEmployer) {
    return <>{verifierName} uses Truework to verify your income</>
  }

  if (targetFirstName) {
    return (
      <>
        <Span className="font-semibold capitalize">{targetFirstName}</Span>, verify your income {employerNameText}
      </>
    )
  }

  return `Verify your income ${employerNameText}`
}

type Props = {
  isMultiEmployer: boolean
  employerName?: string | null
  verifierName?: string | null
  targetFirstName?: string | null
}

export function ConsentHeading({ employerName, verifierName, isMultiEmployer, targetFirstName }: Props) {
  const headerText = getHeaderText({
    employerName,
    verifierName,
    isMultiEmployer,
    targetFirstName,
  })

  return <H2 className="my-6 font-semibold text-moss-700">{headerText}</H2>
}
